/**
 * The tablet device type, for UA parsing.
 * @type {String}
 */
const DESKTOP_DEVICE = 'desktop';

/**
 * The tablet device type, for UA parsing.
 * @type {String}
 */
const TABLET_DEVICE = 'tablet';

/**
 * The mobile device type, for UA parsing.
 * @type {String}
 */
const MOBILE_DEVICE = 'mobile';

/**
 * The ios os name, for UA parsing.
 * @type {String}
 */
const IOS_OS_NAME = 'iOS';

/**
 * The android os name, for UA parsing.
 * @type {String}
 */
const ANDROID_OS_NAME = 'Android';

module.exports = {
    MOBILE_DEVICE,
    TABLET_DEVICE,
    DESKTOP_DEVICE,
    IOS_OS_NAME,
    ANDROID_OS_NAME
};
